import { Component } from '@angular/core';

@Component({
  selector: 'app-new-account-mobile-inactive-state',
  templateUrl: './new-account-mobile-inactive-state.component.html',
  styleUrls: [
    '../../shared-styles/new-account-device-view.component.scss',
    './new-account-mobile-inactive-state.component.scss',
  ],
  standalone: false,
})
export class NewAccountMobileInactiveStateComponent {}
